'use strict';

ClientQueryExecutorFactory.$inject = [
	'mx.shell.SearchProviderService',
	'mx.SolutionBuilderAgent.ExternalServiceManager',
	'$q',
	'$filter',
	'mx.sb.Agent.DataQuery.Enums',
	'mx.SolutionBuilderAgent.ServiceRequestParamsPreprocessor',
	'mx.sb.Agent.DataQuery.FilterOperatorsFactory',
];
export default function ClientQueryExecutorFactory(searchService, externalServiceManager, $q, $filter, dataQueryEnums, ServiceRequestParamsPreprocessor, filterOperatorsFactory) {
	return function ClientQueryExecutor() {
		var data;
		var controlType;
		var dataQuery;
		var executeOptions = {};
		var urlCfg = {};
		var ColumnSortingEnum = dataQueryEnums.ColumnSortingEnum;

		return {
			run: run,
			sortingBuild: sortingBuild,
			paginationBuild: paginationBuild,
			searchBuild: searchBuild,
			init: init,
			getTypes: getTypes,
			supportsGrouping: supportsGrouping,
			columnsBuild: columnsBuild,
			quickFiltersBuild: quickFiltersBuild,
			getServiceUrl: getServiceUrl,
			usePostBack: false,
			getIdentifier: getIdentifier,
		};

		function getServiceUrl() {
			return executeOptions.listUrl;
		}

		function getTypes() {
			var type = executeOptions.typeInfo.TypeName;

			return type ? [type] : [];
		}

		function columnsBuild() {
			return '';
		}

		function init(type, params) {
			controlType = type;
			dataQuery = params.dataQuery;
			executeOptions = externalServiceManager.getListExecuteOptions(dataQuery, mx.SolutionBuilderAgent.SupportedOperations.ReadObjects);
			return [ServiceRequestParamsPreprocessor];
		}

		function sortingBuild(sortColumns) {
			if (controlType === mx.SolutionBuilderAgent.ListingType.grid) {
				return null;
			}

			return {
				executionOrder: 20,
				process: function (objects) {
					return $filter('orderBy')(
						objects,
						sortColumns.map(function (column) {
							return (column.Sorting === ColumnSortingEnum.Descending ? '-' : '+') + column.Name;
						})
					);
				},
			};
		}

		function quickFiltersBuild() {}

		function paginationBuild(pageSize, page) {
			if (controlType === mx.SolutionBuilderAgent.ListingType.grid) {
				return null;
			}

			return {
				executionOrder: 100,
				process: function (objects) {
					return $filter('limitTo')(objects, pageSize, page * pageSize);
				},
			};
		}

		function searchBuild() {
			var searchState = searchService.currentSearch();

			return {
				executionOrder: 10,
				process: function (objects) {
					return objects.filter(filterFn);
				},
			};

			function filterFn(currentObj) {
				var activeFunctions = {};

				if (searchState.keyword) {
					addFn(currentObj, keywordFilter, searchState.keyword);
				}
				addFn(currentObj, queryGroupFilter, searchState.searchForm);

				var res = true;

				if (Object.keys(activeFunctions).length) {
					activeFunctions.forEach();
					_.some(activeFunctions, function (fn) {
						res = res && fn();
						return !res;
					});
				} else {
					res = true;
				}
				return res;

				function addFn(object, fn) {
					if (!activeFunctions.hasOwnProperty(fn.name)) {
						var args = Array.prototype.slice.call(arguments, 2);

						activeFunctions[fn.name] = function () {
							return fn.apply(object, args.unshift(object));
						};
					}
				}

				function conditionFilter(dataItem, condition) {
					var result = true;

					if (typeof condition !== 'undefined' && condition !== null) {
						var property = dataItem[condition.property];

						if (typeof property !== 'undefined') {
							const currentOperator = filterOperatorsFactory.getOperatorByValue(condition.operator);
							if (currentOperator && typeof currentOperator.fn === 'function') {
								result = currentOperator.fn(property, condition.value);
							}
						}
					}
					return result;
				}

				function queryGroupFilter(dataItem, group) {
					var res = true;

					if (typeof group !== 'undefined' && group !== null) {
						_.some(group.conditions, function (condition) {
							if (group.logicalOperator === 1) {
								res = res && conditionFilter.apply(dataItem, [dataItem, condition]);
								return !res;
							}
							res = conditionFilter.apply(dataItem, [dataItem, condition]);
							return res;
						});
						if (res && group.logicalOperator === 1) {
							_.some(group.groups, function (group) {
								if (group.logicalOperator === 1) {
									res = res && queryGroupFilter.apply(dataItem, [dataItem, group]);
									return !res;
								}
								res = queryGroupFilter.apply(dataItem, [dataItem, group]);
								return res;
							});
						}
					}
					return res;
				}

				function keywordFilter(dataItem, keyword) {
					if (!keyword) {
						return true;
					}
					var _keyword = keyword.toLowerCase();

					return _.some(dataItem, function (dataItemProperty) {
						if (typeof dataItemProperty === 'string') {
							return dataItemProperty.toLowerCase().indexOf(_keyword) !== -1;
						}
					});
				}
			}
		}

		function supportsGrouping() {
			return false;
		}

		function run(parts) {
			parts.sort(function (a, b) {
				return a.executionOrder - b.executionOrder;
			});

			return (
				data
					? $q.when(data)
					: executeSource().then(function (d) {
							data = d;
							return d;
					  })
			).then(function (objects) {
				var result = objects;

				parts.forEach(function (filter) {
					result = filter.process(result);
				});

				return {
					data: result,
					totalCount: objects.length,
				};
			});
		}

		function executeSource() {
			var dataRequestUrl = urlCfg.path;

			return executeOptions.httpProvider
				.get(dataRequestUrl)
				.then(executeOptions.processResponse)
				.then(function (response) {
					var data = executeOptions.getProcessedDataFromObject(response);
					if (!Array.isArray(data)) {
						data = [];
						mx.console.error('Wrong response format for: ', dataRequestUrl);
					}
					return data;
				});
		}

		function getIdentifier() {
			return 'Id';
		}
	};
}
